import React from 'react';
import AppLayout from '../components/AppLayout';
import OverviewList from '../components/OverviewList';
import {PageMenu,DeleteListItem,GenerateSpreadsheet,AddListItem,
        DownloadTemplate,DynamicListArea,BulkEdit,LoadGraphic,Step,
        Segment,SegmentComplete} from '../components/Common';
import {EditSizeLabel,EditableBox,EditableSelect,Box,Select,
        TextButton,Button,
        Table} from '../components/Input';
import u from '../utilities/Utilities';
import {Link} from 'react-router-dom';
import PropTypes, { number } from 'prop-types';
import {Spreadsheet} from '../data/Mimetypes';
import moment from 'moment';
import store from 'store';
import "../styles/enhanced-check-list.scss";
import { data } from '../../backend/database/notebook';

export default class EnhancedCheckList extends React.Component{

    settings={
        /**** Page Setup ****/
        title:"Enhanced Check Logs",
        permission:"enhancedCheck",  //Accepts combined permission module as well
        url:"/enhanced-check-list",

        /**** Action Setup ****/
        //addType:2,
        //addURL:"/api/add-staff",
        //templateURL:"/api/get-add-staff-template",
        //bulkURL:"/api/add-bulk-staff",
        //deleteURL:"/api/delete-staff-entries",
        spreadsheetURL:"/api/generate-enhanced-check-spreadsheet",
        overviewURL:"/api/get-all-enhanced-checks",

        /**** List Setup ****/
        list:true,
        listLabel:"enhanced-check-list",
        orderByField:"dateTime",
        orderByType:"descending",
        numRows:20,
        checkboxPermissions:{},
        overview:undefined,
        onPopup:(content)=>{this.refs['layout'].onPopup(content)}
    };

    pageComponents={
        // check:{component:CheckTurnstile,props:{}},
        settings:{component:ConfigureSettings,props:{}},
        calendar:{component:ConfigureCalendar,props:{}},
        spreadsheet:{component:GenerateSpreadsheet,props:{}},
    };

    state={
        selected:{
            tags:[],
            all:false,
            data:[],
            entryCount:0
        },
        pageMenuButtons:[],
        permissions:{},
    };

    componentDidMount=()=>{
        const permissions = u.getPermissions("enhancedCheck");

        this.setState({
            permissions:permissions,
            pageMenuButtons:[
                {label:"Spreadsheet", mobileLabel:"Generate Spreadsheet",ref:"spreadsheet",image:"/images/page-menu/spreadsheet.png",title:"Generate spreadsheet from selection",enabled:permissions.view == 2},
                {label:"Configure Settings", mobileLabel:"Configure Settings",ref:"settings",image:"/images/page-menu/settings.png",title:"Configure list settings and column visibility",enabled:permissions.update == 2},
                {label:"Configure Calendar", mobileLabel:"Configure Calendar",ref:"calendar",image:"/images/page-menu/settings.png",title:"Configure list settings and column visibility",enabled:permissions.update == 2},
                {label:"Configure Override", mobileLabel:"Configure Override",ref:"override",image:"/images/page-menu/override.png",title:"Configure override settings for enhanced checks",enabled:permissions.update == 2, onClick: ()=> {
                    window.open("/enhanced-check-override-list","_blank");
                }},
            ],
        })
    };

    onSelectChange=(selected)=>{
        this.setState({selected:selected});
    };

    render=()=>{
        return (
            <AppLayout ref="layout" settings={this.settings}>

                <div className="page-error">{this.state.error}</div>

                <PageMenu buttons={this.state.pageMenuButtons}
                          settings={this.settings}
                          components={this.pageComponents}
                          selected={this.state.selected}/>

                <OverviewList  ref={(ref)=>{this.settings.overview=ref}}
                               settings={this.settings}
                               onSelectChange={this.onSelectChange}
                               registerReference={this.registerReference}
                               onMutatedChange={this.onMutatedChange}
                               location={this.props.location}
                               ignorePreviousTags={true}>
                    {
                        (content,index,onChange,onContentChange,registerRef)=>{
                            return (
                                <EnhancedCheckItem key={index} index={index} content={content} onChange={onChange} onContentChange={onContentChange} registerReference={registerRef} permissions={this.state.permissions}/>
                            )
                        }
                    }
                </OverviewList>

            </AppLayout>
        )
    }
}

class EnhancedCheckItem extends React.Component{
    state={
        loading:false,
        loadText:"",
        step:"view",
    }

    onClearPassback=()=>{
        this.setState({loading:true,loadText:"Clearing Passback...",error:""});
        u.post({
            url:"/api/access-clear-passback",
            data:{
               type:this.props.content.type,
               id:this.props.content.id,
            },
            success:()=>{
                this.setState({loading:false,step:"success"});
            },
            error:(error)=>{
                this.setState({error:error,loading:false});
            }
        })
    }

    render=()=>{
        const content = this.props.content;

        return (
            <div style={{position:"relative",textAlign:"center"}}>
                <LoadGraphic active={this.state.loading} text={this.state.loadText}/>
                <Step active={this.state.step=="view"}>
                    <DynamicListArea listLabel={"enhanced-check-list"} permission="enhancedCheck" content={this.props.content} onChange={this.props.onChange} index={this.props.index}/>
                </Step>
                <Step active={this.state.step=="success"}>
                    <SegmentComplete onComplete={()=>{this.setState({step:"view"})}}>
                        <h2>Passback cleared successfully</h2>
                    </SegmentComplete>
                </Step>
            </div>
        )
    }
}

class ConfigureSettings extends React.Component{

    state = {
        error: '',
        loading: false,
        loadText: '',
        active:(this.props.active) ? this.props.active : false,
        step:"view",
        entryData: {
            entryAttemptsLimit: 0,
            entryAttemptsPeriod: 0,
            minutesSinceLastExitStart: 0,
            minutesSinceLastExitEnd: 0,
        }
    }

    componentDidMount=()=>{
        this.getCurrentSettings();
    }

    show=(show)=>{
        this.setState({active:show});
    }

    onChange=(value,label,index,option)=>{
        let entryData=this.state.entryData;
        entryData[label] = value;
        this.setState({entryData:entryData});
    }

    getCurrentSettings=()=>{
        this.setState({loading:true,loadText:"Loading settings...",error:""});
        u.post({
            url:"/api/get-enhanced-check-config",
            data:{},
            success:(config)=>{
                this.setState({entryData:config,loading:false,loadText:"",error:""});
            },
            error:(error)=>{
                this.setState({error:error,loading:false,loadText:""});
            }
        })
    }

    onValidate=()=>{
        this.setState({error:""});
        const keys = ["entryAttemptsLimit","entryAttemptsPeriod","minutesSinceLastExitStart","minutesSinceLastExitEnd"];
        let data = {};
        for(var i=0; i<keys.length; i++){
            if(this.refs[keys[i]]){
                const current = this.refs[keys[i]].validate();
                if(!current.valid){
                    this.setState({error:current.value});
                    return 0;
                }
                data[keys[i]] = current.value;
            }
        }

        this.setState({loading:true,loadText:"Updating settings..."});

        console.log("Validated data: ", data);

        u.post({
            url:"/api/update-enhanced-check-config",
            data:{
                entryAttemptsLimit: data.entryAttemptsLimit,
                entryAttemptsPeriod: data.entryAttemptsPeriod,
                minutesSinceLastExitStart: data.minutesSinceLastExitStart,
                minutesSinceLastExitEnd: data.minutesSinceLastExitEnd,
            },
            success:()=>{
                this.setState({loading:false,loadText:"",error:"",step:"complete"});
            },
            error:(error)=>{
                this.setState({error:error,loading:false,loadText:""});
            }
        })
    }

    onCancel=()=>{
        if(this.props.onToggleForm){
            this.props.onToggleForm(this.props.reference,false);
        }
    }

    onComplete=()=>{
        this.setState({
            step:"view",
            error:"",
        });
    }

    render=()=>{
        return (
            <Segment active={this.state.active}>
                <div className='segment-title'>Enhanced Check Settings</div>
                <LoadGraphic active={this.state.loading} text={this.state.loadText}/>
                <Step active={this.state.step=="view"}>
                    <div className='segment-content' style={{position:"relative",textAlign:"center", display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '15px'}}>
                        <div className='segment-full-item'>
                            <div className='segment-item-label' style={{verticalAlign:"middle",fontSize:"1.1em",width:"100%",margin:"0 0 0 1%"}}><b>Priority 1  - How many times he entered within a certain period?</b></div>
                        </div>
                        <div className='segment-full-item'>
                            <div className='row-item' style={{width:"50px",margin:"0 10px"}}>
                                <Box
                                    ref={"entryAttemptsLimit"}
                                    values={{value:this.state.entryData.entryAttemptsLimit}}
                                    onChange={(value,label,index,option)=>{this.onChange(value,"entryAttemptsLimit",index,option)}}
                                    rules={{minValue:0, required:true}}
                                />
                            </div>
                            <div className='row-item'>
                                 <b>Attempts</b> within
                            </div>
                            <div className='row-item' style={{width:"50px",margin:"0 10px"}}>
                                <Box
                                    ref={"entryAttemptsPeriod"}
                                    values={{value:this.state.entryData.entryAttemptsPeriod}}
                                    onChange={(value,label,index,option)=>{this.onChange(value,"entryAttemptsPeriod",index,option)}}
                                    rules={{minValue:0, required:true}}
                                ></Box>
                            </div>
                            <div className='row-item'>
                               <b>Minutes</b>
                            </div>
                        </div>

                        <div className='segment-full-item'>
                            <div className='segment-item-label' style={{verticalAlign:"middle",fontSize:"1.1em",width:"100%",margin:"0 0 0 1%"}}><b>Priority 2 – How close was he from his last exit?</b></div>
                        </div>
                        <div className='segment-full-item'>
                            <div className='row-item' style={{width:"50px",margin:"0 10px"}}>
                                <Box
                                    ref={"minutesSinceLastExitStart"}
                                    values={{value:this.state.entryData.minutesSinceLastExitStart}}
                                    onChange={(value,label,index,option)=>{this.onChange(value,"minutesSinceLastExitStart",index,option)}}
                                    rules={{minValue:0, required:true}}
                                ></Box>
                            </div>
                            <div className='row-item'>
                                  <b>Minutes</b> To
                            </div>
                            <div className='row-item' style={{width:"50px",margin:"0 10px"}}>
                                <Box
                                    ref={"minutesSinceLastExitEnd"}
                                    values={{value:this.state.entryData.minutesSinceLastExitEnd}}
                                    onChange={(value,label,index,option)=>{this.onChange(value,"minutesSinceLastExitEnd",index,option)}}
                                    rules={{minValue:0, required:true}}
                                ></Box>
                            </div>
                            <div className='row-item'>
                                  <b>Minutes</b> since last exit
                            </div>
                        </div>
                        <div className="segment-buttons">
                            <div className="segment-error">Changes will only take effect after you click Save Changes</div>
                        </div>
                        <div className="segment-buttons">
                            <div className="segment-error">{this.state.error}</div>
                            <Button onClick={this.onCancel}>Cancel</Button>
                            <Button onClick={this.onValidate}>Submit</Button>
                        </div>
                    </div>


                </Step>
                <Step active={this.state.step == "complete"} scroll={true}>
                    <div className="segment-content" style={{position:"relative",textAlign:"center"}}>
                        <SegmentComplete onComplete={this.onComplete}>
                            Successfully updated <span className="text-emphasis">enhanced check settings</span>
                        </SegmentComplete>
                    </div>
                </Step>
            </Segment>
        )
    }
}

class ConfigureCalendar extends React.Component{
    state = {
        error: '',
        loading: false,
        loadText: '',
        active:(this.props.active) ? this.props.active : false,
        selectedDay:"",
        step:"view",
    }

    componentDidMount=()=>{
        this.getCurrentSettings();
    }

    show=(show)=>{
        this.setState({active:show});
    }

    getCurrentSettings=()=>{
        this.setState({loading:true,loadText:"Loading settings...",error:""});
        u.post({
            url:"/api/get-enhanced-check-calendar",
            data:{},
            success:(config)=>{
                this.setState({entryData:config,loading:false,loadText:"",error:"", selectedDay:Object.keys(config)[0]});
            },
            error:(error)=>{
                this.setState({error:error,loading:false,loadText:""});
            }
        })
    }

    onNext =()=>{
        const days = Object.keys(this.state.entryData);
        const currentIndex = days.indexOf(this.state.selectedDay);
        const nextIndex = (currentIndex+1)%days.length;
        this.setState({selectedDay:days[nextIndex]});
    }

    onPrevious =()=>{
        const days = Object.keys(this.state.entryData);
        const currentIndex = days.indexOf(this.state.selectedDay);
        const previousIndex = (currentIndex-1+days.length)%days.length;
        this.setState({selectedDay:days[previousIndex]});
    }

    onChange=(value,label,index,option)=>{
        let entryData=this.state.entryData;
        entryData[this.state.selectedDay][index][label] = value;
        this.setState({entryData:entryData});
    }

    onSubmit=()=>{
        this.setState({loading:true,loadText:"Updating calendar settings...",error:""});
        u.post({
            url:"/api/update-enhanced-check-calendar",
            data:{
                calendarSettings:this.state.entryData,
            },
            success:()=>{
                this.setState({loading:false,loadText:"",error:""});
                this.setState({step:"complete"});
            },
            error:(error)=>{
                this.setState({error:error,loading:false,loadText:""});
            }
        })
    }

    onCancel=()=>{
        if(this.props.onToggleForm){
            this.props.onToggleForm(this.props.reference,false);
        }
    }

    onComplete=()=>{
        this.setState({
            step:"view",
            error:"",
        });
    }

    render=()=>{
        return (
            <Segment active={this.state.active}>
                <div className='segment-title'>Enhanced Check Calendar Settings</div>
                <LoadGraphic active={this.state.loading} text={this.state.loadText}/>
                <Step active={this.state.step=="view"}>
                    <div className='segment-content' style={{position:"relative",textAlign:"center", display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '15px'}}>
                            <div className='day-selector-container '>
                                <img src="/images/input/list-arrow.png" className="paging-arrow" onClick={()=>{this.onPrevious()}}/>
                                <span className='day-selector'>{this.state.selectedDay}</span>
                                <img src="/images/input/list-arrow.png" className="paging-arrow right" onClick={()=>{this.onNext()}}/>
                            </div>
                            <div className='list-table' style={{maxHeight:"400px"}}>

                            <table>
                                <thead style={{position:"sticky",top:0, zIndex:1}}>
                                    <tr>
                                        <th>Time Slot</th>
                                        <th>A (No Exit Request Today)</th>
                                        <th>B (Exit Request Today)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        (this.state.entryData && this.state.selectedDay && this.state.entryData[this.state.selectedDay]) ?
                                        this.state.entryData[this.state.selectedDay].map((item,index)=>{
                                            return (
                                                <tr key={index}>
                                                    <td>{item.startTime} - {item.endTime}</td>
                                                    <td ><div className='rate-box'>
                                                        <Box
                                                        values={{value:item.a_rate}}
                                                        index={index}
                                                        field={"a_rate"}
                                                        onChange={(value,label,index,option)=>{this.onChange(value,label,index,option)}}
                                                    />per 1000</div></td>
                                                    <td><div className='rate-box'>
                                                        <Box
                                                        values={{value:item.b_rate}}
                                                        index={index}
                                                        field={"b_rate"}
                                                        onChange={(value,label,index,option)=>{this.onChange(value,label,index,option)}}
                                                    />per 1000</div></td>
                                                </tr>
                                            )
                                        })
                                        :
                                        <tr>
                                            <td colSpan={3}>No data</td>
                                        </tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                    <div className="segment-buttons">
                        <div className="segment-error">{this.state.error}</div>
                        <Button onClick={this.onCancel}>Cancel</Button>
                        <Button onClick={this.onSubmit}>Submit</Button>
                    </div>
                    </div>
                </Step>
                <Step active={this.state.step == "complete"} scroll={true}>
                    <div className="segment-content" style={{position:"relative",textAlign:"center"}}>
                        <SegmentComplete onComplete={this.onComplete}>
                            Successfully updated <span className="text-emphasis">enhanced check calendar settings</span>
                        </SegmentComplete>
                    </div>
                </Step>
            </Segment>
        )
    }
}